import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NotificationTypeModel } from './typings/notification-type';

const ICONS : { [ type : string ] : string } = {
  danger : 'ban',
  info   : 'info-circle',
  success: 'check-circle',
  warning: 'exclamation-triangle'
};

// An inline notice with a functional colour, a message and an optional action such as Retry
@Component({
  selector   : 'wor-notification',
  template: require('./notification.component.html')
})
export class NotificationComponent {
  @Input() actionLabel : string                = '';
  @Input() detail      : string                = '';
  // a banner is one line sized to its content with the action beside it; the card is 402px, stacked
  @Input() isBanner    : boolean               = false;
  @Input() message     : string                = '';
  @Input() type        : NotificationTypeModel = 'info';

  @Output() action : EventEmitter<void> = new EventEmitter<void>();

  get icon () : string {
    return ICONS[ this.type ] || ICONS.info;
  }

  // errors and warnings interrupt a screen reader; information and success wait their turn
  get role () : string {
    return this.type === 'danger' || this.type === 'warning'
      ? 'alert'
      : 'status';
  }
}
